import type { LicenceResponse } from '@shared/schemas';

import type { LicenceDraft, LoadStatus, SaveStatus } from '../domain/licence-draft.model';
import type { MyLicenceError } from '../domain/my-licence-error';

/**
 * Redux state for the owner's My Licence settings form. A single-field edit form,
 * so the shape is small: the loaded licence (header + rename target id), the
 * editable draft, the load + save lifecycles, per-field validation errors, and the
 * last business error. Every field is serialisable.
 */
export interface MyLicenceState {
  licence: LicenceResponse | null;
  draft: LicenceDraft;
  loadStatus: LoadStatus;
  saveStatus: SaveStatus;
  validationErrors: Record<string, string>;
  error: MyLicenceError | null;
}

export const emptyDraft: LicenceDraft = { name: '' };

export const initialState: MyLicenceState = {
  licence: null,
  draft: emptyDraft,
  loadStatus: 'idle',
  saveStatus: 'idle',
  validationErrors: {},
  error: null,
};
